import styled from 'styled-components';

export const FilterTitleRow = styled.div`
  display: flex;
  padding: 8px 0 24px;
  justify-content: space-between;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0;
`;

export const PageTitle = styled.span`
  font-size: 26px;
  color: #000;
`;

export const ColStyle = {
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '24px',
};

export const FormTitle = styled.span`
  white-space: nowrap;
  padding-right: 8px;
`;

export const ModalColumnTitle = styled.span`
  padding-left: 12px;
`;

export const ModalColumnSwitchItem = styled.div`
  width: 330px;
  display: inline-block;
  margin-top: 16px;
`;

// date picker related styles
export const DatePickContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ShortCutItem = styled.span`
  border: 1px solid #d0d0d0;
  padding: 0 16px;
  display: inline-flex;
  height: 32px;
  align-items: center;
  cursor: pointer;

  &:first-child {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
`;

export const EmptyInfo = styled.p`
  color: #111;
`;
